import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useRouter } from 'vue-router'

import ConfirmModal from '@/components/ConfirmModal.vue'
import RecordButton from '@/components/customers/record/RecordButton.vue'
import RecordCard from '@/components/customers/record/RecordCard.vue'
import RecordSettingRow from '@/components/customers/record/RecordSettingRow.vue'
import api from '@/store/api'


export default {
  __name: 'ProfileArchive',
  props: {
  conversationUserPairId: { type: String, required: true }
},
  setup(__props) {

const props = __props

const router = useRouter()
const confirming = ref(false)

const archiveConversationUserPair = () => {
  confirming.value = false
  api.call('DELETE', `conversation_user_pairs/${props.conversationUserPairId}`)
  router.push('/messages')
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(RecordCard, {
    "data-test": "danger-zone-card",
    title: "Danger zone",
    danger: ""
  }, {
    default: _withCtx(() => [
      _createVNode(RecordSettingRow, {
        title: "Archive customer",
        description: "Hides them from your contact lists. Orders and messages are kept, and they come back if they text you or pay for an order."
      }, {
        default: _withCtx(() => [
          _createVNode(RecordButton, {
            "data-test": "archive-customer",
            variant: "danger",
            size: "sm",
            onClick: _cache[0] || (_cache[0] = $event => (confirming.value = true))
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Archive customer ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ConfirmModal, {
        "is-open": confirming.value,
        title: "Archive this customer?",
        message: "They'll leave your contact lists. Their orders and messages are kept.",
        "confirm-label": "Archive",
        onConfirm: archiveConversationUserPair,
        onClose: _cache[1] || (_cache[1] = $event => (confirming.value = false))
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

}